import { GATEWAY_URL } from "../../env";
import request from "../Request";
import cookieManager from "../CookieManager";
import Constants from "../Constants";

class GeoLocationHelper {
    /**
     * Resolves the user's country by IP via the gateway and stores it in the
     * `country` / `country_code` cookies. These cookies feed the `country`
     * field of the session-data header, which LiveOps uses to segment remote
     * config campaigns. Call before RemoteConfigService.init() so the buttons
     * are resolved with the right country.
     */
    static async resolveCountryByIP(logContext = "GeoLocationHelper") {
        try {
            const res = await request.POST(`${GATEWAY_URL}/GeoLocation/GetCountryByIP`);
            console.log(`[${logContext}] GetCountryByIP response:`, res);

            if (res?.status === true) {
                const code = res?.data?.countryCode || res?.countryCode || "";
                cookieManager.set(Constants.COUNTRY_CODE, code);
                const country = res?.data?.country || res?.country || "";
                cookieManager.set(Constants.COUNTRY, country);
            } else {
                console.warn(`[${logContext}] Geo IP failed: ${res?.StatusCode} - ${res?.Message}`);
            }
        } catch (error) {
            console.error(`[${logContext}] Error resolving country by IP:`, error);
        }
    }
}

export default GeoLocationHelper;
